export const featuresSelector = ({ billing }) => {
  const { userFeatures } = billing

  if (userFeatures) return userFeatures.features

  throw new Error('isAvailableFeatureSelector: Cannot find user features')
}
